(function () {
    'use strict';

    var imApp = angular.module('imApp');

    imApp.filter('trustedReportUrl', ['$sce', function ($sce) {
        return $sce.trustAsResourceUrl;
    }]);
})();